import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import GetPrice from "./GetPrice";
import "./GetProducts.css";

import { useNavigate } from "react-router-dom";
import toastify from "../Util/toastify";
import BaseURL from "../Util/BaseURL";
window.g = 0;
function GetProducts(props) {
  const [data, setData] = useState([]);
  const [cart, setCart] = useState();
  const [products, setProducts] = useState();
  const [quantity, setQuantity] = useState();
  const [price, setPrice] = useState();
  const [total, setTotal] = useState();
  const [pro, setPro] = useState();
  var nav = useNavigate();
  function navigate(props) {
    nav("/Products", { state: { productId: props } });
  }

  function minus(props) {
    if (quantity == 1) {
      document.getElementById(props + "minus").disabled = "true";
    } else {
      let s = quantity - 1;
      setQuantity(s);
      update(s);
      let t = total - price;
      setTotal(t);
      window.g = window.g - price;
    }
  }

  function plus() {
    let s = quantity + 1;
    setQuantity(s);
    update(s);
    let t = total + price;
    setTotal(t);
    window.g = window.g + price;
  }
  async function update(q) {
    if (data.quantity < q) {
      toastify(
        "Quantity out of stock \n Only" + data.quantity + " left",
        "error"
      );
    } else {
      axios.post(
        `${BaseURL}UpdateCart?id=${props.props}&name=${sessionStorage.getItem(
          "user"
        )}&quantity=${q}`
      );
    }
  }
  async function removeItem(id) {
    const r = await axios.get(
      `${BaseURL}getCart?name=${sessionStorage.getItem("user")}`,
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    axios.delete(
      `${BaseURL}deleteItem?id=${id}&name=${sessionStorage.getItem("user")}`
    );
    if (r.data.length === 1) nav(0);
    else document.getElementById(id).style.display = "none";
  }
  const getData = async () => {
    const res = await axios.get(`${BaseURL}getProduct?id=${props.props}`);
    setData(res.data);
  };

  const getCart = async () => {
    const r = await axios.get(
      `${BaseURL}getCartById?name=${sessionStorage.getItem("user")}&id=${
        props.props
      }`,
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    setCart(r.data);
    setTotal(r.data[0].price * r.data[0].quantity);
    window.g = window.g + total;
    setPrice(r.data[0].price);
    setQuantity(r.data[0].quantity);
  };

  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    getCart();
  }, []);
  return (
    <>
      <tr id={data.productId}>
        <td
          className="title"
          id="title"
          onClick={() => navigate(data.productId)}
        >
          {data.title}
        </td>
        <td>{price}</td>
        <td className="quantity" id="quantity">
          <i
            onClick={() => minus(data.productId)}
            className="fas fa-minus-circle minus"
            id={data.productId + "minus"}
          ></i>
          {quantity}
          <i className="fas fa-plus-circle plus" onClick={() => plus()}></i>
        </td>
        <td className="total" id="total">
          {total}
          <i
            role="button"
            className="fas fa-times-circle"
            style={{ marginLeft: "10px", color: "black" }}
            onClick={() => removeItem(data.productId)}
          ></i>
        </td>
      </tr>
    </>
  );
}
export default GetProducts;
